import { pushDataLayer } from '~/src/features/payments-abn/components/SeasonTicketPayment/helpers';
import { setBonusesAmount } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/actionCreators';
import { EPaymentTypeIds, setPaymentTypeId } from '~/src/features/payments-abn/store/actionCreators';
import { TAppThunkDispatch, TGetState } from '~/src/store';

const updatePaymentTypeId = (id: EPaymentTypeIds) => {
    return async(dispatch: TAppThunkDispatch, getState: TGetState): Promise<void> => {
        const {
            loyalty: { info: { bonuses } },
            wholesaleCheaperData: { wholesaleCheaperData },
        } = getState();

        dispatch(setPaymentTypeId(id));

        if (id === EPaymentTypeIds.WHOLESALE) {
            pushDataLayer('subscription_payment');
            dispatch(setBonusesAmount(Math.min(bonuses, Math.ceil(wholesaleCheaperData?.availableFlags[0]?.paySum || 0))));
        }
    };
};

export default updatePaymentTypeId;
